/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import {
  convertDataForCarbonDetailSavingsMeter,
  getCarbonTotalEmissionMeterDetails,
  getUtilityTypeMeterCarbonDetails
} from '../../../shared/Utils/CarbonViewDetailsUtils';
import {
  CarbonDetailExpandMeterField,
  UtilityType
} from '../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { ICarbonData } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import DetailBreakdownByMeter from '../../../shared/DetailBreakdownByMeter/DetailBreakdownByMeter';
import { ApiContext } from '../../../../context/ApiContext';

interface ITotalEmissionsSavingsByMeterDetailComponentProps {
  data: ICarbonData;
}

export const TotalEmissionsSavingsByMeterDetailComponent = (
  props: ITotalEmissionsSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const { data } = props;
  const {
    emissionMeasurementUnit,
    emissionsByUtility,
    breakdownByMeter
  } = data;

  const apiContext = useContext(ApiContext);

  const CarbonMeterSavingdata = convertDataForCarbonDetailSavingsMeter(
    emissionsByUtility,
    emissionMeasurementUnit,
    apiContext.showChangeWhenData
  );

  const { values, displayUnit } = CarbonMeterSavingdata;

  const CarbonUtilityTypeMeterDetails = getUtilityTypeMeterCarbonDetails(
    breakdownByMeter,
    emissionMeasurementUnit,
    displayUnit,
    apiContext.showChangeWhenData
  );

  const TotalEmissionUtilitydetails = {
    meterSavingdata: values,
    utilityTypeMeterDetails: CarbonUtilityTypeMeterDetails
  };

  const Utilitydetails = getCarbonTotalEmissionMeterDetails([
    TotalEmissionUtilitydetails
  ]);

  const columnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: CarbonDetailExpandMeterField.meter,
      header: t(d.METER),
      sortable: true,
      initialWidth: '6%'
    },
    {
      className: 'datatable-column-utilityType',
      field: CarbonDetailExpandMeterField.utilityType,
      header: t(d.UTILITYTYPE),
      sortable: true,
      initialWidth: '5%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonDetailExpandMeterField.actualConsumption,
      header: t(d.ACTUALEMISSION),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonDetailExpandMeterField.baselineConsumption,
      header: t(d.PREVIOUSEMISSION),
      sortable: true,
      initialWidth: '13%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonDetailExpandMeterField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '7%'
    }
  ];

  return (
    <div className="emaas-Metersaving-details-head">
      <DetailBreakdownByMeter
        meterData={Utilitydetails}
        utilityMeasurementUnit={displayUnit}
        columnDetails={columnDetails}
        utilityType={UtilityType.CO2}
        emissionMeasurementUnit={emissionMeasurementUnit}
      />
    </div>
  );
};
export default TotalEmissionsSavingsByMeterDetailComponent;
